/**
 * Entry point for Stakeholder Presentation
 * Ensures Firebase is properly initialized before rendering any components
 */

// Initialize Firebase first, before any components
import './firebase/firebase';
console.log('[MAIN] Firebase initialized');

// Clear local storage on app start for consistent testing
console.log('[MAIN] Clearing localStorage for consistent testing');
localStorage.removeItem('jimi_firstName');
localStorage.removeItem('jimi_acknowledged');

import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { methodistTheme } from './styles/theme';

const theme = extendTheme(methodistTheme);

// Render the application
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
);
